module.exports = __webpack_public_path__ + "img/badge-recommendations-gold-darkbg.71d1907d.svg";